import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
// mui imports
import {
  ListItemIcon,
  ListItem,
  List,
  styled,
  ListItemText,
  Chip,
  useTheme,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const NavItem = ({ item, level, pathDirect, onClick, hideMenu }) => {
  const customizer = useSelector((state) => state.customizer);
  const Icon = item.icon;
  const SelectedIcon = item.selectedIcon;
  const theme = useTheme();
  const { t } = useTranslation();
  const itemIcon =
    level > 1 ? <Icon style={{ fontSize: '1.1rem' }} /> : <Icon style={{ fontSize: '1.5rem' }} />;
  // level > 1 ? <Icon stroke={1.5} size="1rem" /> : <Icon stroke={1.5} size="1.3rem" />;

  const itemSelectedIcon =
    level > 1 ? (
      <SelectedIcon style={{ fontSize: '1.1rem' }} />
    ) : (
      <SelectedIcon style={{ fontSize: '1.5rem' }} />
    );
  // level > 1 ? (
  //   <SelectedIcon stroke={1.5} size="1rem" />
  // ) : (
  //   <SelectedIcon stroke={1.5} size="1.3rem" />
  // );

  // Get the first three segments of the path, e.g., /masters/category or /masters/lectures
  const basePath = item.href.split('/').slice(0, 3).join('/');

  const ListItemStyled = styled(ListItem)(() => ({
    whiteSpace: 'nowrap',
    marginBottom: '12px',
    padding: '5px 10px',
    borderRadius: `${customizer.borderRadius}px`,

    // Check if pathDirect contains the base path of item.href

    backgroundColor:
      level > 1 && pathDirect.startsWith(basePath) ? `#941b0c !important` : 'inherit',

    boxShadow: level > 1 && pathDirect.startsWith(basePath) ? '1px 1px 8px #ff9770' : 'none',

    color: level > 1 && pathDirect.startsWith(basePath) ? `#fff!important` : '#FF8343',

    '&:hover': {
      backgroundColor: '#fc7a1e',
      color: '#fff',
    },
    '&.Mui-selected': {
      color: 'white',
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: '#fc7a1e',
        color: 'white',
      },
    },
  }));

  return (
    <List component="li" disablePadding key={item.id}>
      <ListItemStyled
        button
        component={item.external ? 'a' : NavLink}
        to={item.href}
        href={item.external ? item.href : ''}
        disabled={item.disabled}
        selected={pathDirect === item.href}
        target={item.external ? '_blank' : ''}
        onClick={onClick}
      >
        <ListItemIcon
          sx={{
            minWidth: '36px',
            p: '3px 0',
            color: level > 1 && pathDirect === item.href ? `#fff !important` : 'inherit',
          }}
        >
          {pathDirect === item.href ? itemSelectedIcon : itemIcon}
        </ListItemIcon>

        <ListItemText
          sx={{
            marginLeft: level > 1 && '15px',
            whiteSpace: 'normal',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {hideMenu ? '' : <>{t(`${item.title}`)}</>}
          <br />
          {item.subtitle ? (
            <Typography variant="caption" sx={{ whiteSpace: 'normal' }}>
              {hideMenu ? '' : item.subtitle}
            </Typography>
          ) : (
            ''
          )}
        </ListItemText>

        {!item.chip || hideMenu ? null : (
          <Chip
            color={item.chipColor}
            variant={item.variant ? item.variant : 'filled'}
            size="small"
            label={item.chip}
          />
        )}
      </ListItemStyled>
    </List>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number,
  pathDirect: PropTypes.any,
  hideMenu: PropTypes.any,
  onClick: PropTypes.func,
};

export default NavItem;
